var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Nav'),_c('router-view'),_c('Footer'),_c('Login',{directives:[{name:"show",rawName:"v-show",value:(_vm.Login_show),expression:"Login_show"}],ref:"Login",on:{"close":function($event){_vm.Login_show=false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }